import * as Sentry from '@sentry/react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'
import React from 'react'

import { EXTENSION_PROTOCOLS, IGNORED_EXTENSION_MESSAGES } from '../constants/sentry'

const hasExtensionFrame = (event) =>
  event.exception?.values?.some((exception) =>
    exception.stacktrace?.frames?.some((frame) =>
      EXTENSION_PROTOCOLS.some((protocol) => frame.filename?.startsWith(protocol))
    )
  )

const hasIgnoredExtensionMessage = (event) =>
  event.exception?.values?.some((exception) =>
    IGNORED_EXTENSION_MESSAGES.some((message) => exception.value?.includes(message))
  )

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,

  beforeSend(event) {
    if (hasExtensionFrame(event) && hasIgnoredExtensionMessage(event)) {
      return null
    }

    return event
  },

  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  debug: import.meta.env.VITE_SENTRY_DEBUG_MODE === 'true',
})

export default Sentry
